"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldNames = exports["default"] = void 0;
exports.useLocationAddressFields = useLocationAddressFields;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _lodash = require("lodash");
var _utils = require("./utils");
var _isAddressValid = _interopRequireDefault(require("./utils/isAddressValid"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/** Field keys expected by the LocationAddressField component. */
var fieldNames = exports.fieldNames = ['line_1', 'city', 'county', 'state', 'postal_code', 'country', 'latitude', 'longitude'];

/**
 * Helper hook to setup the fields required by the LocationAddressField component.
 *
 * Only works with react-final-form.
 * You can pass the resulting object to the LocationAddressField component.
 *
 * Note: The useField hook is passed through dependency injection to avoid some
 * dependency issues with react-final-form.
 *
 * @param {Function} useField The useField hook from react-final-form.
 * @param {Object} [configs] An object with the field names as keys and the field configs as values.
 * @returns {Object} An object with the field names as keys and the field objects as values.
 */
function useLocationAddressFields(useField) {
  var configs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.fromEntries(fieldNames.map(function (fn) {
    var config = configs[fn] || {};
    return [fn, useField(fn, config)];
  }));
}
var debouncedGetAutoCompleteOptions = (0, _lodash.debounce)(_utils.getAutoCompleteOptions, 200);
var LocationAddressField = function LocationAddressField(props) {
  var className = props.className,
    id = props.id,
    label = props.label,
    fieldNamePath = props.fieldNamePath,
    google = props.google,
    required = props.required,
    initialTouched = props.initialTouched,
    cityRequiredMessage = props.cityRequiredMessage,
    requiredMessage = props.requiredMessage,
    placeholder = props.placeholder,
    dataTestId = props.dataTestId;
  var addressData = fieldNamePath ? props[fieldNamePath] : props;
  var invalidAddressMsg = cityRequiredMessage;
  var isValid = (0, _isAddressValid["default"])(addressData, required);
  var _useState = (0, _react.useState)({
      name: id || 'pseudo-address',
      value: (0, _utils.stringifyAddress)(addressData),
      valid: isValid,
      invalid: !isValid,
      visited: false,
      active: false,
      touched: initialTouched,
      dirty: false,
      pristine: true,
      error: isValid ? undefined : invalidAddressMsg
    }),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  (0, _react.useEffect)(function () {
    setAddress(_objectSpread(_objectSpread({}, address), {}, {
      value: (0, _utils.stringifyAddress)(addressData),
      valid: isValid,
      invalid: !isValid
    }));
  }, [addressData.line_1, addressData.city, addressData.county, addressData.country, addressData.postal_code, addressData.state]);
  var _useState3 = (0, _react.useState)({
      open: false,
      results: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    dropdown = _useState4[0],
    setDropdown = _useState4[1];
  var onAddressChange = function onAddressChange(event) {
    (0, _utils.updateFieldsValues)(null, addressData);
    var value = event.target.value;
    // timeout set to push setAddress value AFTER useEffect hook triggered by updateFieldsValues
    setTimeout(function () {
      setAddress(_objectSpread(_objectSpread({}, address), {}, {
        value: value,
        valid: false,
        invalid: true,
        pristine: false,
        dirty: true,
        touched: true,
        error: invalidAddressMsg
      }));
    }, 0);
    return debouncedGetAutoCompleteOptions(value, function (results) {
      return setDropdown({
        open: true,
        results: results
      });
    }, google);
  };
  var onAddressFocus = function onAddressFocus() {
    setAddress(_objectSpread(_objectSpread({}, address), {}, {
      active: true,
      touched: address.dirty
    }));
    if (dropdown.results.length !== 0) {
      setDropdown(_objectSpread(_objectSpread({}, dropdown), {}, {
        open: true
      }));
    }
  };
  var onAddressBlur = function onAddressBlur(event) {
    setAddress(_objectSpread(_objectSpread(_objectSpread({}, address), !event.target.value ? {
      error: required ? requiredMessage : undefined,
      valid: !required,
      invalid: required
    } : {}), {}, {
      active: false,
      visited: true,
      touched: true,
      pristine: false
    }));
  };
  var onResultClick = function onResultClick(result) {
    return function () {
      var service = new google.maps.places.PlacesService(document.createElement('div'));
      service.getDetails({
        placeId: result.place_id,
        fields: ['address_components', 'geometry.location']
      }, function (PlaceResult, PlacesServiceStatus) {
        if (PlacesServiceStatus === google.maps.places.PlacesServiceStatus.OK) {
          var resultObj = _objectSpread(_objectSpread({}, result), {}, {
            result: _objectSpread({}, PlaceResult),
            latLng: {
              lat: PlaceResult.geometry.location.lat(),
              lng: PlaceResult.geometry.location.lng()
            }
          });
          (0, _utils.updateFieldsValues)(resultObj, addressData);
          setDropdown(_objectSpread(_objectSpread({}, dropdown), {}, {
            open: false
          }));
        }
      });
    };
  };
  var onResultKeyDown = function onResultKeyDown(result) {
    return function (event) {
      // Capture Enter and Space keys
      if (['Enter', ' '].includes(event.key)) {
        event.preventDefault();
        onResultClick(result)();
      }
    };
  };
  var onCloseDropDown = function onCloseDropDown() {
    setDropdown(_objectSpread(_objectSpread({}, dropdown), {}, {
      open: false
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-address-field ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(id, "-address"),
    className: "location-address-field__address-field"
  }, /*#__PURE__*/_react["default"].createElement(_ui.InputField, _extends({
    id: "".concat(id, "-address-field"),
    label: label
  }, address, {
    onChange: onAddressChange,
    onFocus: onAddressFocus,
    onBlur: onAddressBlur,
    required: required,
    placeholder: placeholder,
    dataTestId: dataTestId
  })), dropdown.open && /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-address-field__dropdown-close-btn"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    id: "address-dropdown-close-btn",
    icon: "IconTimes",
    onClick: onCloseDropDown
  })), dropdown.open && /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-address-field__dropdown"
  }, dropdown.results.map(function (result) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: result.id,
      className: "location-address-field__dropdown-item",
      role: "button",
      onClick: onResultClick(result),
      onKeyDown: onResultKeyDown(result),
      tabIndex: "0"
    }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      icon: "V2MapPin",
      color: "#4467AB"
    }), result.address);
  }), dropdown.results.length === 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-address-field__dropdown-item location-address-field__dropdown-item--no-matches"
  }, "No matches found"))));
};
LocationAddressField.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string.isRequired,
  /** className for reference */
  className: _propTypes["default"].string,
  /** label text for button */
  label: _propTypes["default"].string.isRequired,
  /** path to the address object from the Fields names */
  fieldNamePath: _propTypes["default"].string,
  /** the google maps object */
  google: _propTypes["default"].object.isRequired,
  /** pass required to InputField for address */
  required: _propTypes["default"].bool,
  // Make zip code a required field.
  initialTouched: _propTypes["default"].bool,
  cityRequiredMessage: _propTypes["default"].string,
  requiredMessage: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
LocationAddressField.defaultProps = {
  className: '',
  fieldNamePath: 'address',
  required: true,
  initialTouched: false,
  cityRequiredMessage: 'City is required',
  requiredMessage: 'Required',
  placeholder: '',
  dataTestId: ''
};
var _default = exports["default"] = LocationAddressField;